import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import { checkAuth, getAccountProfile, updateAccountProfile, changePassword, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';

export default function EditProfile() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const getAccountProfileRes = useSelector(state => state.userReducer.getAccountProfile);

  const getAccountProfileFailed = useSelector(state => state.userReducer.getAccountProfileFailed);

  const updateAccountProfileRes = useSelector(state => state.userReducer.updateAccountProfile);

  const updateAccountProfileFailed = useSelector(state => state.userReducer.updateAccountProfileFailed);

  const changePasswordRes = useSelector(state => state.userReducer.changePassword);
  const changePasswordFailed = useSelector(state => state.userReducer.changePasswordFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);


  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState(false);

  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState(false);

  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [phone, setPhone] = useState("");
  const [errorPhone, setErrorPhone] = useState(false);
  const [invalidPhone, setInvalidPhone] = useState(false);

  const [phone2, setPhone2] = useState("");
  const [errorPhone2, setErrorPhone2] = useState(false);
  const [invalidPhone2, setInvalidPhone2] = useState(false);

  const [address, setAddress] = useState("");
  const [errorAddress, setErrorAddress] = useState(false);

  const [address2, setAddress2] = useState("");

  const [city, setCity] = useState("");
  const [errorCity, setErrorCity] = useState(false);

  const [state, setState] = useState("");
  const [errorState, setErrorState] = useState(false);

  const [country, setCountry] = useState("");
  const [errorCountry, setErrorCountry] = useState(false);

  const [pinCode, setPinCode] = useState("");
  const [errorPinCode, setErrorPinCode] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [errorCurrentPass, setErrorCurrentPass] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [errorNewPass, setErrorNewPass] = useState(false);

  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [errorConfirmNewPass, setErrorConfirmNewPass] = useState(false);
  const [errorNotMatchingPass, setErrorNotMatchingPass] = useState(false);

  var calls = 1;

  useEffect(() => {
    console.log("calls", calls);
    calls++;
    dispatch(checkAuth());
    dispatch(getAccountProfile());
  }, []);
 

  useEffect(() => {

    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      logout();
      navigate("/signin");
    }

  }, [checkAuthFailed]);

  useEffect(() => {

    if(typeof getAccountProfileRes != "undefined" && getAccountProfileRes.statusCode == 200){
      console.log("getAccountProfileRes", getAccountProfileRes);

      let data = getAccountProfileRes.data;

      setFirstName(data.firstName);
      setLastName(data.lastName);
      setEmail(data.user.email);
      setPhone(data.phone);
      setPhone2(data.phone2);
      setAddress(data.address1);
      setAddress2(data.address2)
      setCity(data.city);
      setState(data.state);
      setCountry(data.country);
      setPinCode(data.pinCode);
    }

  }, [getAccountProfileRes]);


  useEffect(() => {

    if(typeof updateAccountProfileRes != "undefined" && updateAccountProfileRes.statusCode == 200){

      console.log(updateAccountProfileRes.message);

      setShowSuccessAlert(true);

      setTimeout(()=>{
        setShowSuccessAlert(true);
      },5000);


    }

  }, [updateAccountProfileRes]);
  
  // useEffect(() => {   
  //   if(typeof changePasswordRes != "undefined" && changePasswordRes.statusCode == 200){
  //     setCurrentPassword("");
  //     setNewPassword("");
  //     setConfirmNewPassword("");

  //     toast.success(changePasswordRes.message, {position: "bottom-right", autoClose:4000,onClose: () => {
  //         setCurrentPassword("");
  //         setNewPassword("");
  //         setConfirmNewPassword("");

  //         setErrorCurrentPass(false);
  //         setErrorNewPass(false);
  //         setErrorConfirmNewPass(false);
  //         setErrorNotMatchingPass(false);
  //     }});
  //   }
  // }, [changePasswordRes]);

  useEffect(() => {
      if (changePasswordRes) {
        if (changePasswordRes.status === "error") { 
          toast.error(changePasswordRes.message || "Update failed", {
            position: "bottom-right",
            autoClose: 4000,
          });
        } else if (changePasswordRes.statusCode === 200) {
          toast.success(changePasswordRes.message || "Password updated successfully",{
            position: "bottom-right",
            autoClose: 4000,
          });
          setCurrentPassword("");
          setNewPassword("");
          setConfirmNewPassword("");

          setErrorCurrentPass(false);
          setErrorNewPass(false);
          setErrorConfirmNewPass(false);
          setErrorNotMatchingPass(false);
        }
      }
    }, [changePasswordRes]);

    useEffect(() => {
      if(typeof changePasswordFailed != "undefined" && changePasswordFailed.statusCode == 400){
        toast.error(changePasswordFailed.message, {position: "bottom-right", autoClose:4000});
      }
    }, [changePasswordFailed]);

  /*useEffect(() => {
    
    if(typeof createCustomerRes != "undefined" && createCustomerRes.statusCode == 200){

      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setPhone2("");
      setAddress("");
      setAddress2("")
      setCity("");
      setState("");
      setCountry("");
      setPinCode("");

      toast.success(createCustomerRes.message, {position: "bottom-right", autoClose:4000,onClose: () => {
        dispatch(resetCreateCustomer());
      }});
    }

  }, [createCustomerRes]);*/


  /*useEffect(() => {
    // console.log(getBotOperatorFailed);
    if(createCustomerFailed && createCustomerFailed.statusCode == 401){
          toast.error(createCustomerFailed.message, {autoClose:6000,onClose: () => {
                logout();
                navigate("/login");
          }});
    }
  }, [createCustomerFailed]);*/

  const handleChangepassword = (input, event) => {
    var value = event.target.value;

    if(input == "currentPassword"){
      setCurrentPassword(value);
    }

    if(input == "newPassword"){
      setNewPassword(value);
    }

    if(input == "confirmNewPassword"){
      setConfirmNewPassword(value);
    }
  };

  const handleChangeNew = (input, event) => {
    
    var value = event.target.value;

    if(input == "firstName"){
      setFirstName(value);
    }

    if(input == "lastName"){
      setLastName(value);
    }

    if(input == "email"){
      setEmail(value);
    }

    if(input == "phone"){
      setPhone(value);
    }

    if(input == "phone2"){
      setPhone2(value);
    }

    if(input == "address"){
      setAddress(value);
    }

    if(input == "address2"){
      setAddress2(value);
    }

    if(input == "city"){
      setCity(value);
    }
    
    if(input == "state"){
      setState(value);
    }
    
    if(input == "country"){
      setCountry(value);
    }
    
    if(input == "pinCode"){
      setPinCode(value);
    }

  };

  const validateEmail = (emailVal) => {
    return String(emailVal)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = (e) => {

    console.log("===========");

    e.preventDefault();

    setErrorFirstName(false);
    setErrorLastName(false);
    setErrorEmail(false);
    setInvalidEmail(false);
    setErrorPhone(false);
    setInvalidPhone(false);    
    setErrorPhone2(false);
    setInvalidPhone2(false);
    setErrorAddress(false);
    setErrorCity(false);
    setErrorState(false);
    setErrorCountry(false);
    setErrorPinCode(false);
    console.log("===========2");
    var err = [];
    if(firstName.replace(/\s/g, '') == ""){
      err.push("First name");
      setErrorFirstName(true);
    }

    console.log("===========3");

    if(lastName.replace(/\s/g, '') == ""){
      err.push("Last name");
      setErrorLastName(true);
    }
    
    if(email.replace(/\s/g, '') == ""){
      err.push("Email");
      setErrorEmail(true);
    }
    // else if(validateEmail(email)){
    //   setErrorEmail(true);
    //   setInvalidEmail(true); 
    // }
    else if(!validateEmail(email)){
      err.push("Email");
      setErrorEmail(true);
      setInvalidEmail(true); 
    }

    console.log("===========5");
    if(phone.replace(/\s/g, '') == ""){
      err.push("Phone");
      setErrorPhone(true);
    }
    else if( !isNaN(parseInt(phone)) && phone.length !== 10){
      setErrorPhone(true);
      setInvalidPhone(true); 
    }

    console.log("===========6");

    if(phone2.replace(/\s/g, '') == ""){
      err.push("Secondary phone");
      setErrorPhone2(true);
    }
    else if(!isNaN(parseInt(phone2)) &&  phone2.length !== 10){
      setErrorPhone2(true);
      setInvalidPhone2(true); 
    }

    console.log("===========7");

    if(address.replace(/\s/g, '') == ""){
      err.push("address");
      setErrorAddress(true);
    }

    console.log("===========8");

    /*if(address2.replace(/\s/g, '') == ""){
      err.push("address2");
    }*/

    if(city.replace(/\s/g, '') == ""){
      err.push("city");
      setErrorCity(true);
    }

    console.log("===========9");

    if(state.replace(/\s/g, '') == ""){
      err.push("state");
      setErrorState(true);
    }

    console.log("===========10");

    if(country.replace(/\s/g, '') == ""){
      err.push("country");
      setErrorCountry(true);
    }

    console.log("===========11");

    if(pinCode.replace(/\s/g, '') == ""){
      err.push("pincode");
      setErrorPinCode(true);
    }

    console.log("===========12");

    console.log("}}}}}}}}}", err.length);
    
    if(err.length === 0){
        let data = {
          "firstName" : firstName,
          "lastName" : lastName,
          "phone" : phone,
          "phone2": phone2,
          "address" : address,
          "address2": address2,
          "city" : city,
          "state": state,
          "country" : country,
          "pinCode": pinCode,
          "email" : email,

        };
        console.log("Enetered if lenfth")
        dispatch(updateAccountProfile(data));
    }
    else{
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };

  
  const handleChangePasswordSubmit = (e) => {
    e.preventDefault();

    setErrorCurrentPass(false);
    setErrorNewPass(false);
    setErrorConfirmNewPass(false);
    setErrorNotMatchingPass(false);

    let err = 0;

    if(currentPassword.replace(/\s/g, '') == ""){
      err++;
      setErrorCurrentPass(true);
    }

    if(newPassword.replace(/\s/g, '') == ""){
      err++;
      setErrorNewPass(true);
    }

    if(confirmNewPassword.replace(/\s/g, '') == ""){
      err++;
      setErrorConfirmNewPass(true);
    }

    if(newPassword !== confirmNewPassword){
      err++;
      setErrorConfirmNewPass(true);
      setErrorNotMatchingPass(true);
    }
    
    if(err === 0){
        let data = {
          "currentPassword" : currentPassword,
          "newPassword" : newPassword,
          "confirmPassword" : confirmNewPassword
        };
        dispatch(changePassword(data));
    }
    else{
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };


  const resetForm = (e) => {
      e.preventDefault();

      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setPhone2("");
      setAddress("");
      setAddress2("")
      setCity("");
      setState("");
      setCountry("");
      setPinCode("");

      setErrorFirstName(false);
      setErrorLastName(false);
      setErrorEmail(false);
      setInvalidEmail(false);
      setErrorPhone(false);
      setInvalidPhone(false);    
      setErrorPhone2(false);
      setInvalidPhone2(false);
      setErrorAddress(false);
      setErrorCity(false);
      setErrorState(false);
      setErrorCountry(false);
      setErrorPinCode(false);
  }
  const resetPasswordForm = (e) => {
      e.preventDefault();

      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");

      setErrorCurrentPass(false);
      setErrorNewPass(false);
      setErrorConfirmNewPass(false);
      setErrorNotMatchingPass(false);
  }
  
  return (        
    <div>
      <PageMeta
        title="Account profile | Chit Fund Management System"
        description="Acount profile info - Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Account Profile" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">

        <div className="space-y-6">
          <ComponentCard title="Edit your profile info">
            {(
              showSuccessAlert 

              ? 

              <Alert
                variant="success"
                title="Done!"
                message="customer successfully Updated."
                showLink={false}
              />

              : 
              
              null
            )}
            <form onSubmit={handleSubmit} className='fadein'>

              <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">

                <div className="space-y-6">
                  <div>
                    <Label>First Name <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the First Name" 
                      error={errorFirstName} 
                      value={firstName} 
                      onChange={(e) => handleChangeNew("firstName", e)} 
                      hint={errorFirstName ? "This field is required." : ""} 
                    />
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <Label>Last Name <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Last Name" 
                      error={errorLastName} 
                      value={lastName} 
                      onChange={(e) => handleChangeNew("lastName", e)} 
                      hint={errorLastName ? "This field is required." : ""} 
                    />
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <Label>Phone number <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Phone number" 
                      error={errorPhone} 
                      value={phone} 
                      onChange={(e) => handleChangeNew("phone", e)} 
                      hint={errorPhone ? (invalidPhone ? "Please Enter 10 digit valid phone no." : "This field is required.") : "" } 
                    />
                  </div>
                </div>
                <div className="space-y-6">
                  <div>
                    <Label>Secondary Phone number <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Alternative Phone number" 
                      error={errorPhone2} 
                      value={phone2} 
                      onChange={(e) => handleChangeNew("phone2", e)} 
                      hint={errorPhone2 ? (invalidPhone2 ? "Please Enter 10 digit valid phone no." : "This field is required.") : "" } 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Address <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Address" 
                      error={errorAddress} 
                      value={address} 
                      onChange={(e) => handleChangeNew("address", e)} 
                      hint={errorAddress ? "This field is required." : ""} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Address2</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Address2" 
                      value={address2} 
                      onChange={(e) => handleChangeNew("address2", e)} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>City <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the city" 
                      error={errorCity} 
                      value={city} 
                      onChange={(e) => handleChangeNew("city", e)} 
                      hint={errorCity ? "This field is required." : ""} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>State <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the State" 
                      error={errorState} 
                      value={state} 
                      onChange={(e) => handleChangeNew("state", e)} 
                      hint={errorState ? "This field is required." : ""} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Country <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Country" 
                      error={errorCountry} 
                      value={country} 
                      onChange={(e) => handleChangeNew("country", e)} 
                      hint={errorCountry ? "This field is required." : ""} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Pincode <span className="text-red-500">*</span></Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Pincode" 
                      error={errorPinCode} 
                      value={pinCode} 
                      onChange={(e) => handleChangeNew("pinCode", e)} 
                      hint={errorPinCode ? "This field is required." : ""} 
                    />
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Email ID <span className="text-red-500">*</span></Label>
                    <Input 
                      type="email" 
                      placeholder="Enter the Email ID" 
                      error={errorEmail} 
                      value={email} 
                      onChange={(e) => handleChangeNew("email", e)} 
                      hint={errorEmail ? (invalidEmail ? "Please Enter valid Email address." : "This field is required.") : "" } 
                    />
                  </div>
                </div>

              </div>
              <div className="space-x-6 mt-6">
                  <Button size="sm" variant="primary" startIcon={<CheckLineIcon />}>
                    Submit
                  </Button>
                  <Button size="sm" onClick={resetForm} variant="outline" startIcon={<CloseLineIcon />}>
                    Cancel
                  </Button>
              </div>
            </form>
          </ComponentCard>
        </div>

        <div className="space-y-6">
          <ComponentCard title="Change password">
            <form onSubmit={handleChangePasswordSubmit} className='fadein'>
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
              <div className="space-y-6">
                  <div>
                    <Label>Current Password <span className="text-red-500">*</span></Label>
                    <div className="relative">
                      <Input
                        type={showCurrentPassword ? "text" : "password"}
                        placeholder="Enter your current password"
                        error={errorCurrentPass} 
                        value={currentPassword} 
                        onChange={(e) => handleChangepassword("currentPassword", e)} 
                        hint={errorCurrentPass ? "This field is required." : ""}
                      />
                      <Link
                        to={"javascript:void(0);"}
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                        className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                      >
                        {showCurrentPassword ? (
                          <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                        ) : (
                          <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                        )}
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>New Password <span className="text-red-500">*</span></Label>
                    <div className="relative">
                      <Input
                        type={showNewPassword ? "text" : "password"}
                        placeholder="Enter your new password"
                        error={errorNewPass} 
                        value={newPassword} 
                        onChange={(e) => handleChangepassword("newPassword", e)} 
                        hint={errorNewPass ? "This field is required." : ""}
                      />
                      <button
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                      >
                        {showNewPassword ? (
                          <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                        ) : (
                          <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div>
                    <Label>Confirm New Password <span className="text-red-500">*</span></Label>
                    <div className="relative">
                      <Input
                        type={showConfirmNewPassword ? "text" : "password"}
                        placeholder="Enter your new password"
                        error={errorConfirmNewPass} 
                        value={confirmNewPassword} 
                        onChange={(e) => handleChangepassword("confirmNewPassword", e)} 
                        hint={errorConfirmNewPass ? (errorNotMatchingPass ? "New Password and Confirm Password doesn't match." : "This field is required.") : ""}
                      />
                      <button
                        onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                        className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                      >
                        {showConfirmNewPassword ? (
                          <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                        ) : (
                          <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="space-x-6">
                    <Button size="sm" variant="primary" startIcon={<CheckLineIcon />}>
                      Submit
                    </Button>
                    <Button size="sm" onClick={resetPasswordForm} variant="outline" startIcon={<CloseLineIcon />}>
                      Cancel
                    </Button>
                </div>
              </div>
            </form>
          </ComponentCard>
        </div>

      </div>
      <ToastContainer />
    </div>
  );
}
